import { useDispatch, useSelector } from "react-redux";
import { useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GDeleteModal from "components/ui/modal/DeleteModal";
import { deletePromotion } from "../../services/promotionsService";

const DeleteModal = ({
  data,
  onClose
}) => {
  const { t } = useTranslation();
  const toast = useToast({ position: "top", duration: 3000, status: "success" });
  const dispatch = useDispatch();
  const promotions = useSelector(state => state.promotions);

  return (
    <GDeleteModal
      onClose={onClose}
      onSubmit={() => {
        dispatch(deletePromotion({ id: data.id }))
          .unwrap()
          .then(_ => {
            toast({ description: t("pages.promotions.promotion_deleted") });
            onClose();
          })
      }}
      isLoading={promotions.isLoading}
    />
  )
}

export default DeleteModal